import React, { useState, useEffect, useRef } from 'react';
import { getImagePath, siteConfig } from '../config/siteConfig';
import '../styles/Header.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const scrollPositionRef = useRef(0);
  const { company, social } = siteConfig;

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileMenuOpen) {
      scrollPositionRef.current = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPositionRef.current}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    } else if (document.body.style.position === 'fixed') {
      const scrollY = Math.abs(parseInt(document.body.style.top || '0', 10));
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY || scrollPositionRef.current);
    }
  }, [mobileMenuOpen]);

  useEffect(() => {
    return () => {
      if (document.body.style.position === 'fixed') {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
      }
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setMobileMenuOpen(false);
      }
    };

    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <header className={`header-glass ${scrolled ? 'scrolled' : ''}`}>
      <nav className="navbar-glass">
        <div className="nav-container-glass">
          <div className="nav-brand">
            <a href="/" className="brand-link">
              <img src={getImagePath("/assets/images/logo/logo.png")} alt="AirYouGo" className="brand-logo" />
            </a>
          </div>

          <div className={`nav-menu-glass ${mobileMenuOpen ? 'active' : ''}`}>
            <ul className="nav-list-glass">
              <li className="nav-item-glass">
                <a href="/" className="nav-link-glass" onClick={closeMobileMenu}>Home</a>
              </li>
              <li className="nav-item-glass">
                <a href="#packages" className="nav-link-glass" onClick={closeMobileMenu}>Packages</a>
              </li>
              <li className="nav-item-glass">
                <a href="#about" className="nav-link-glass" onClick={closeMobileMenu}>About</a>
              </li>
              <li className="nav-item-glass">
                <a href="#faq" className="nav-link-glass" onClick={closeMobileMenu}>FAQ</a>
              </li>
            </ul>

            <div className="mobile-menu-extras">
              <a href={`https://wa.me/${company.whatsapp.replace(/[^\d]/g, '')}`} className="mobile-cta" target="_blank" rel="noopener noreferrer" onClick={closeMobileMenu}>
                <i className="fab fa-whatsapp"></i>
                <span>Chat on WhatsApp</span>
              </a>
              <a href={`tel:${company.phone.replace(/\s+/g, '')}`} className="mobile-cta" onClick={closeMobileMenu}>
                <i className="fas fa-phone"></i>
                <span>Call {company.phone}</span>
              </a>
              {social.instagram && (
                <a href={social.instagram} className="mobile-cta" target="_blank" rel="noopener noreferrer" onClick={closeMobileMenu}>
                  <i className="fab fa-instagram"></i>
                  <span>Instagram</span>
                </a>
              )}
            </div>
          </div>

          <button
            type="button"
            className={`mobile-overlay ${mobileMenuOpen ? 'active' : ''}`}
            onClick={closeMobileMenu}
            aria-label="Close mobile menu"
          />

          <div className="nav-actions-glass">
            <a href="#contact" className="btn-contact-glass">
              <i className="fas fa-phone"></i>
              <span>Contact Us</span>
            </a>
          </div>

          <button 
            type="button"
            className="mobile-toggle" 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;
